import { render, staticRenderFns } from "./step-two.page.vue?vue&type=template&id=e51c7628&"
import script from "./step-two.page.vue?vue&type=script&lang=ts&"
export * from "./step-two.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports